import { render, staticRenderFns } from "./Edition.vue?vue&type=template&id=56b671e7&scoped=true&"
import script from "./Edition.vue?vue&type=script&lang=js&"
export * from "./Edition.vue?vue&type=script&lang=js&"
import style0 from "./Edition.vue?vue&type=style&index=0&id=56b671e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b671e7",
  null
  
)

export default component.exports